import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography,} from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlatDpe from "./FaltDpe";
import {bdnb_millesime} from "../pages/dpeByIris/MapPage";
import DpeV1Details from "./v2/DpeV1Details";

export const resDpeV1 = {
    classe: "D",
    dpes: [
        {dpe: "G",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "F",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "E",ges:"G",inertie:"moyenne", isolEnv:"moyenne", isolMenu:"moyenne", isolMur:"très bonne"},
        {dpe: "D",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "C",ges:"C",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "B",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"moyenne", isolMur:"très bonne"},
        {dpe: "A",ges:"A",inertie:"moyenne", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "D",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "C",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"moyenne", isolMur:"très bonne"},
        {dpe: "B",ges:"A",inertie:"moyenne", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},
        {dpe: "A",ges:"A",inertie:"lourde", isolEnv:"moyenne", isolMenu:"bonne", isolMur:"très bonne"},

    ]

}

export default function AttributDpeV1({selectedItem}) {
    const [enableModule, setEnableModule] = React.useState(true);


    return (<Accordion
        sx={{
            margin: 2,
            '&:before': {
                display: 'none',
            },
            boxShadow: "none",
            borderColor: "rgba(0, 0, 0, 0.125)",
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: "8px"
        }}
        disabled={false}
        expanded={!enableModule}

    >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon/>}
            onClick={()=>{
                setEnableModule(!enableModule)
            }}>

        <Typography>Données DPE  Logements réalisés avant juillet 2021 (à titre informatif)</Typography>

        </AccordionSummary>
        <AccordionDetails>
            <DpeV1Details selectedItem={selectedItem}/>
        </AccordionDetails>
    </Accordion>)
}
